export default __webpack_public_path__ + "static/media/Neck_Pain.72e8e2c5.png";